import React from "react";

function Dashboard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      viewBox="0 0 256 256"
    >
      <g fill="currentColor">
        <path d="M96 37.5v72l-62.4 36A96 96 0 0196 37.5z" opacity="0.2"></path>
        <path d="M100 116.43a8 8 0 004-6.93v-72A8 8 0 0093.34 30a104.06 104.06 0 00-67.61 117 8 8 0 004.52 5.81 7.86 7.86 0 003.35.74 8 8 0 004-1.07zM88 49.62v55.26l-47.88 27.63C40 131 40 129.48 40 128a88.12 88.12 0 0148-78.38zm130.34 26.9c-.09-.18-.18-.37-.29-.55s-.2-.33-.31-.49A104.05 104.05 0 00128 24a8 8 0 00-8 8v91.83l-78.81 45.9a8 8 0 00-2.87 11A104 104 0 00232 128a103.34 103.34 0 00-13.66-51.48zM136 40.36a88.05 88.05 0 0163.89 36.94L136 114.51zM128 216a88.45 88.45 0 01-71.49-36.68l75.4-43.91.22-.14 75.77-44.13A88 88 0 01128 216z"></path>
      </g>
    </svg>
  );
}

export default Dashboard;
